import { FormCreationData } from "../../../../../stateManager/store/formCreation_v2/types";

class Stack {
  protected data: FormCreationData[] = [];
  constructor() {
    this.data = [];
  }

  push(value: FormCreationData) {
    this.data.push(value);
  }
  pop(): FormCreationData | undefined {
    return this.data.pop();
  }
  top() {
    return this.data[this.data.length - 1];
  }
  getStack() {
    return this.data;
  }
}

class UndoStack extends Stack {
  // private variable to store the order;
  private order: string[] = []
  
  saveOrder(order: string[]) {
    this.order = order;
  }

  getOrder() {
    return this.order;
  }
}


export class RedoStack extends Stack {

  clear() {
    this.data = [];
  }
  // Todo: remove this
  getStack() {
    return this.data;
  }
}

export const myUndoStack = new UndoStack();
export const myRedoStack = new RedoStack();

